import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';

import { SuxTranslateService } from '@suva-ch/suvauxlib/modules/translation';

@Component({
  selector: 'kvb-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  encapsulation: ViewEncapsulation.ShadowDom,
})
export class AppComponent implements OnInit {
  @Input() language = 'de';

  constructor(private suxTranslateService: SuxTranslateService) {}

  ngOnInit(): void {
    this.suxTranslateService.init(this.language);
  }
}
